import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    selectedDemande: null,
});

const getters = {
    all: state => state.all,
    one: state => state.one
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_SELECTED_DEMANDE(state, demande) {
        state.selectedDemande = demande;
    },
    CLEAR_SELECTED_DEMANDE(state) {
        state.selectedDemande = null;
    },
};

const actions = {
    async getAll(cxt) {
        let data = await client.get('demandes/all');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllP({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', chiffreAffaire, montantCotisation, montantFraisDeDossier, cotisationFixeMaintien, cotisationVariableMaintien, state, type, codeRef, sexe, email, sousLibelle, sousCode, imported, treatmentDateAfter, treatmentDateBefore, after, before, dateValidationPaiementAfter, dateValidationPaiementBefore } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(chiffreAffaire && { chiffreAffaire }),
            ...(montantCotisation && { montantCotisation }),
            ...(montantFraisDeDossier && { montantFraisDeDossier }),
            ...(cotisationFixeMaintien && { cotisationFixeMaintien }),
            ...(cotisationVariableMaintien && { cotisationVariableMaintien }),
            ...(state && { state }),
            ...(type && { type }),
            ...(codeRef && { codeRef }),
            ...(sexe && { sexe }),
            ...(email && { email }),
            ...(sousLibelle && { sousLibelle }),
            ...(sousCode && { sousCode }),
            ...(imported && { imported }),
            ...(treatmentDateAfter && { treatmentDateAfter }),
            ...(treatmentDateBefore && { treatmentDateBefore }),
            ...(after && { after }),
            ...(before && { before }),
            ...(dateValidationPaiementAfter && { dateValidationPaiementAfter }),
            ...(dateValidationPaiementBefore && { dateValidationPaiementBefore }),
        }).toString();
        let { data } = await client.get(`demandes/inscription?${queryParams}`);
        commit("SET_ALL", data)
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllPMaintient({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', chiffreAffaire, montantCotisation, montantFraisDeDossier, cotisationFixeMaintien, cotisationVariableMaintien, state, type, codeRef, sexe, email, sousLibelle, sousCode, imported, treatmentDateAfter, treatmentDateBefore, after, before, dateValidationPaiementAfter, dateValidationPaiementBefore } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(chiffreAffaire && { chiffreAffaire }),
            ...(montantCotisation && { montantCotisation }),
            ...(montantFraisDeDossier && { montantFraisDeDossier }),
            ...(cotisationFixeMaintien && { cotisationFixeMaintien }),
            ...(cotisationVariableMaintien && { cotisationVariableMaintien }),
            ...(state && { state }),
            ...(type && { type }),
            ...(codeRef && { codeRef }),
            ...(sexe && { sexe }),
            ...(email && { email }),
            ...(sousLibelle && { sousLibelle }),
            ...(sousCode && { sousCode }),
            ...(imported && { imported }),
            ...(treatmentDateAfter && { treatmentDateAfter }),
            ...(treatmentDateBefore && { treatmentDateBefore }),
            ...(after && { after }),
            ...(before && { before }),
            ...(dateValidationPaiementAfter && { dateValidationPaiementAfter }),
            ...(dateValidationPaiementBefore && { dateValidationPaiementBefore }),
        }).toString();
        let { data } = await client.get(`demandes/maintien?${queryParams}`);
        commit("SET_ALL", data)
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async getOne(cxt, id) {
        let data = await client.get('demandes/one/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('demandes/edit/' + payload.id, payload) : await client.post('demandes/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }

        return data;
    },
    async suiviDemande(cxt, payload) {
        let data = await client.post('demandes/suivi', payload);
        cxt.commit("SET_ONE", data);
        cxt.commit("SET_SELECTED_DEMANDE", data);
        return data;
    },
    async del(cxt, id) {
        let { data } = await client.delete('demandes/delete/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async receptionDemande(cxt, id) {
        let { data } = await client.get('demandes/activate/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async traitementDemande(cxt, payload) {
        let data = await client.post('demandes/treat', payload);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async renouvellement(cxt, payload) {
        let { data } = await client.post('demandes/add/corrigee', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }

        return data;
    },
    async getAllDemandeConnectee(cxt) {
        let data = await client.get('/demandes/connected');
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async statistiqueGlobale() {
        let data = await client.get('/stat/all');
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async statistiquePerso () {
        let data = await client.get('/stat/connectedAll');
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async validationComite(cxt, payload) {
        let { data } = await client.post('demandes/validate', payload);
        return data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
